import { ButtonHoc } from '../Helpers/ButtonHoc';
var TertiaryButton = ButtonHoc({
  rippleColor: 'bgTargetTertiary',
  textColorDefault: 'textCTATertiary',
  textColorDisabled: 'textCTATertiaryDisabled',
  bgColorDefault: 'bgCTATertiary',
  bgColorHover: 'bgHoverTertiary',
  bgColorDisabled: 'bgActionTertiary',
  loaderColor: 'textPrimary',
  shadowType: 'shadow8'
});
export default TertiaryButton;